import { BudgetVersionType } from './../shared/enum/budgetVersionType.enum';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IBudgetGeneral } from './../budgets/budget-general/budget-general.model';

@Injectable({
    providedIn: 'root',
})
export class BudgetGeneralService {
    baseUrl = '/school-service/api/budget-general';

    constructor(private http: HttpClient) {}

    getByBudgetId(budgetId: string, version: BudgetVersionType): Observable<HttpResponse<IBudgetGeneral[]>> {
        return this.http.get<IBudgetGeneral[]>(`${this.baseUrl}/budget/${budgetId}/version/${version}`, {
            observe: 'response',
        });
    }

    getCalculatedGenerals(budgetId: string, version: BudgetVersionType): Observable<HttpResponse<IBudgetGeneral[]>> {
        return this.http.get<IBudgetGeneral[]>(`${this.baseUrl}/budget/${budgetId}/version/${version}/calculate`, {
            observe: 'response',
        });
    }

    saveAll(
        budgetId: string,
        version: BudgetVersionType,
        budgetExpenses: IBudgetGeneral[]
    ): Observable<HttpResponse<IBudgetGeneral[]>> {
        return this.http.post<any>(`${this.baseUrl}/budget/${budgetId}/version/${version}/save`, budgetExpenses, {
            observe: 'response',
        });
    }

    approveByBudgetIdAndVersion(
        budgetId: string,
        version: BudgetVersionType
    ): Observable<HttpResponse<IBudgetGeneral[]>> {
        return this.http.patch<any>(`${this.baseUrl}/budget/${budgetId}/version/${version}/approve`, {
            observe: 'response',
        });
    }

    unapproveByBudgetIdAndVersion(
        budgetId: string,
        version: BudgetVersionType
    ): Observable<HttpResponse<IBudgetGeneral[]>> {
        return this.http.patch<any>(`${this.baseUrl}/budget/${budgetId}/version/${version}/unapprove`, {
            observe: 'response',
        });
    }

    deleteByBudgetIdAndVersion(budgetId: string, version: BudgetVersionType): Observable<HttpResponse<any>> {
        return this.http.delete(`${this.baseUrl}/budget/${budgetId}/version/${version}`, {
            observe: 'response',
        });
    }
}
